export default __webpack_public_path__ + "static/media/new-16.779f0fda.png";